import React from "react";
import loadImage from "blueimp-load-image";
import Select, { components } from "react-select";
import { TerritoryOptions } from "../../Constants/retailer";
import { similarity } from "../../functions/index";
import "./index.css";

const UKIcon = require("../../assets/media/countries/uk.png");
const USAIcon = require("../../assets/media/countries/usa.png");
const IrelandIcon = require("../../assets/media/countries/ireland.png");
const CanadaIcon = require("../../assets/media/countries/canada.png");
const AustraliaIcon = require("../../assets/media/countries/australia.png");
const FranceIcon = require("../../assets/media/countries/france.png");
const GermanIcon = require("../../assets/media/countries/german.png");
const IndiaIcon = require("../../assets/media/countries/india.png");
const SouthAfricaIcon = require("../../assets/media/countries/south-africa.png");

const TerritoryIcon = {
  UK: UKIcon,
  Ireland: IrelandIcon,
  USA: USAIcon,
  Canada: CanadaIcon,
  Australia: AustraliaIcon,
  German: GermanIcon,
  France: FranceIcon,
  India: IndiaIcon,
  SouthAfrica: SouthAfricaIcon
};

const MenuList = (props) => {
  const { options, setValue } = props;
  return (
    <components.MenuList {...props}>
      {options.map((option) => (
        <div
          className="territory-menu-item"
          onClick={() => {
            setValue(option);
          }}
        >
          <img src={TerritoryIcon[option.value]} alt="type" />
          {option.label}
        </div>
      ))}
    </components.MenuList>
  );
};

const SingleValue = ({ children, data, ...props }) => {
  return (
    <components.SingleValue {...props}>
      <div className="territory-selected-value">
        <img src={TerritoryIcon[data.value]} alt="type" />
        {data.label}
      </div>
    </components.SingleValue>
  );
};
class MyModal extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      content: "",
      similar_brands: [],
      umbrella: false,
      isDuplicate: false,
      isnext: false,
    };
  }
  handleChangeChk = () => {
    const { umbrella } = this.state;
    this.setState({ umbrella: !umbrella });
  };
  onChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };
  onChangeBrandName = (e) => {
    let brand = e.target.value;
    this.getSimilarBrands(brand);
    console.log("brand", brand);
    if (!brand) this.setState({ isnext: false });
    if (this.checkBrandNameDuplicate(brand)) {
      console.log("duplicated");
      this.setState({ isDuplicate: true, isnext: false });
    } else {
      console.log("no duplicate");
      this.setState({ isDuplicate: false });
    }
    this.setState({ brand: brand });
  };
  getSimilarBrands = (brand_name) => {
    const { brands } = this.props;
    if (brands) {
      let similar_brands = brands.filter(
        (brand) =>
          similarity(brand.name.toLowerCase(), brand_name.toLowerCase()) > 0.5
      );
      console.log("similar_brands", similar_brands);
      this.setState({ similar_brands });
    }
  };
  selectedFile = (e) => {
    let _this = this;
    let id = e.target.id;
    if (e.target.files && e.target.files[0]) {
      var content = e.target.files[0];
      loadImage.parseMetaData(content, function (data) {
        //default image orientation
        var orientation = 0;
        if (data.exif) {
          orientation = data.exif.get("Orientation");
        }
        loadImage(
          content,
          function (canvas) {
            var base64data = canvas.toDataURL("image/png");
            var img_src = base64data.replace(/^data\:image\/\w+\;base64\,/, "");
            _this.setState({ [id]: img_src });
          },
          {
            canvas: true,
            orientation: orientation,
          }
        );
      });
    }
  };
  checkBrandNameDuplicate = (brand_name) => {
    const { brands } = this.props;
    if (brands) {
      let found = brands.find(
        (brand) => brand.name.toLowerCase() === brand_name.toLowerCase()
      );
      if (found) return true;
      else return false;
    }
  };
  addImage = () => {
    const { brand, url, logo_img, icon_img, hex, territory, umbrella } = this.state;
    const { addImage, isSuperAdmin } = this.props;
    if (brand && url && hex && logo_img && icon_img) {
      addImage(
        brand,
        url,
        logo_img,
        icon_img,
        hex,
        territory.value,
        isSuperAdmin ? umbrella : false
      );
    } else alert("Please fill all fields to create a brand.");
  };
  handleChangeTerritory = (territory) => {
    this.setState({ territory });
  };
  render() {
    const { brand, url, hex, territory, umbrella, isDuplicate, similar_brands, isnext } =
      this.state;
    const { isSuperAdmin } = this.props;

    return (
      <div
        className="modal fade"
        id="add_brand"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="modal-default-fadein"
        aria-hidden="true"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Add Brand</h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body pb-1">
              <div>
                <label htmlFor="example-text-input">Brand Name</label>
                <div className="row-div" style={{ marginBottom: 15 }}>
                  <input
                    type="text"
                    name="brand"
                    value={brand}
                    placeholder="Input brand name here.."
                    onChange={this.onChangeBrandName}
                  />
                  {/* <button
                    className="btn btn-green"
                    disabled={isDuplicate || !brand ? true : false}
                    onClick={() => {
                      this.setState({ isnext: true });
                    }}
                  >
                    Next
                  </button> */}
                </div>

                {similar_brands.length > 0 && (
                  <p style={{ color: "red", marginTop: 10 }}>
                    We have existing brands that have similar brand name
                  </p>
                )}
                {similar_brands.length > 0 && (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    {similar_brands.map((brand) => {
                      return (
                        <p style={{ marginLeft: 10, fontWeight: "700" }}>
                          {brand.name}
                        </p>
                      );
                    })}
                  </div>
                )}
              </div>
              <React.Fragment>
                <div className="form-group">
                  <label htmlFor="example-text-input">Brand Url</label>
                  <input
                    type="text"
                    name="url"
                    value={url}
                    className="form-control"
                    placeholder="Input brand url here.."
                    onChange={this.onChange}
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="example-text-input">Brand Logo</label>
                  <input
                    type="file"
                    id="logo_img"
                    name="logo-file-input"
                    accept="image/*"
                    onChange={this.selectedFile}
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="example-text-input">Brand Icon</label>
                  <input
                    type="file"
                    id="icon_img"
                    name="icon-file-input"
                    accept="image/*"
                    onChange={this.selectedFile}
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="example-text-input">Brand hex</label>
                  <input
                    type="text"
                    name="hex"
                    value={hex}
                    className="form-control"
                    placeholder="Input hex code.."
                    onChange={this.onChange}
                  />
                </div>
                <p className="section-title">Territory</p>
                <div className="territory-container">
                  <Select
                    value={territory}
                    onChange={this.handleChangeTerritory}
                    options={TerritoryOptions.map((item) => ({
                      value: item,
                      label: item,
                    }))}
                    isSearchable={false}
                    components={{ MenuList, SingleValue }}
                  />
                </div>
                {isSuperAdmin && (
                  <div className="form-group">
                    <p>Umbrella Brand</p>
                    <input
                      type="checkbox"
                      name="umbrella"
                      value={umbrella}
                      onChange={this.handleChangeChk}
                    />
                  </div>
                )}
              </React.Fragment>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-sm btn-light"
                data-dismiss="modal"
              >
                Close
              </button>
              <button
                type="button"
                className="btn btn-sm btn-success"
                data-dismiss="modal"
                onClick={this.addImage}
              >
                Add
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default MyModal;



// WEBPACK FOOTER //
// ./src/components/MyModal/index.js